import { FunctionComponent } from 'react';
import * as vp from 'vopay';
import { useParams, useHistory } from 'react-router-dom';
import { usePartnerData } from '@/providers/PartnerData.provider';

const { Box, Button, Select, TextField } = vp;

type SearchAccountsProps = {
  countries: string[];
  canCreateAccount: boolean;
  searchTerm: string;
  handleSearchTermChange: (event: string) => void;
  handleExportCSV: (accountId: string | undefined) => void;
  country: string;
  handleCountryChange: (event: string) => void;
  details: vp.AccountDetailsMap;
};

type FC = FunctionComponent<SearchAccountsProps>;

const SubAccountSearchForm: FC = (props: SearchAccountsProps) => {
  const { accountId } = useParams<{ accountId: string }>();
  const {
    response: { isRoleViewOnly },
  } = usePartnerData();

  const history = useHistory();
  const {
    countries,
    canCreateAccount,
    searchTerm,
    handleSearchTermChange,
    handleExportCSV,
    country,
    handleCountryChange,
    details,
  } = props;

  const countryObject = Object.fromEntries(
    countries.map((curr) => {
      if (curr === '') {
        return ['', 'All '];
      }
      return [curr, curr];
    }),
  ) as { [key: string]: string };

  const countryOptions = {
    '': 'Select Country',
    ...countryObject,
  };

  return (
    <Box pt="md" ai="center">
      <Box width="100%" flx="row" jc="sb">
        <Box flx="row">
          <Box mb="sm" pe="sm" width="150px">
            <Select
              placeholder="Country"
              options={countryOptions}
              name="country"
              onBlur={() => {}}
              onChange={(e) => {
                handleCountryChange(e.target.value);
              }}
              value={country}
              variant="outlined"
            />
          </Box>
          <Box mb="sm" pe="sm">
            <TextField
              key="Keyword"
              name="keyword"
              placeholder="Keyword"
              onBlur={() => {}}
              onChange={(e) => {
                handleSearchTermChange(e.target.value);
              }}
              value={searchTerm}
              variant="outlined"
              height="37px"
            />
          </Box>
        </Box>
        <Box>
          <Box jc="fe" pe="sm">
            <Button
              id="sub-accounts-ExportCSV"
              type="button"
              color="secondary"
              label="Export CSV"
              isDisabled={isRoleViewOnly}
              onClick={() => {
                handleExportCSV(details[accountId]?.accountId || '');
              }}
            />
          </Box>
          <Box jc="fe" pe="sm">
            {canCreateAccount && (
              <Button
                id="accounts-addAccount"
                label="Add Account"
                isDisabled={isRoleViewOnly}
                onClick={() => history.push('/accounts/create')}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SubAccountSearchForm;
